<shared-header [isBooking]="true"></shared-header>
<router-outlet></router-outlet>

